<template>
  <el-dialog :visible.sync="show"
             :title="$t('privateNetInstance.unBindTitle')"
             :close-on-click-modal="false"
             :before-close="handleClose"
             class="del-root">
    <p>{{ $t('privateNetInstance.sureUnBindTip', [vpcName]) }}</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelUnbind">{{ $t('privateNetInstance.cancel') }}</el-button>
      <el-button @click="sureUnbind" type="primary" :loading="loading">{{ $t('privateNetInstance.sure') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PrivateNetInstanceList',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    vpcName: {
      type: String,
      default: 'lbs'
    },
    elasticIpId: {
      type: String,
      default: ''
    },
    instanceId: {
      type: String,
      default: ''
    },
    region: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      loading: false, // 添加loading状态
    };
  },
  methods: {
    handleClose() {
      this.show = false;
      this.$emit('update:visible', false);
    },
    cancelUnbind() {
      this.handleClose();
    },
    sureUnbind() {
      // 防止重复点击
      if (this.loading) return;
      
      this.loading = true;
      
      const params = {
        region: this.region,
        instanceId: this.instanceId,
        elasticIpId: this.elasticIpId
      };
      Ajax.put('/api/cps/disassociateElasticIp', params)
        .then((res) => {
          // this.$message.success(this.$t('privateNetInstance.operateSuccess'));
        })
        .catch(async (err) => {
          const { response } = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally(() => {
          this.handleClose();
          this.$emit('refresh');
          // 延迟重置loading状态，确保弹窗完全关闭后再重置
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    }
  },
  watch: {
    visible(newVal) {
      this.show = newVal;
    }
  }
};
</script>

<style scoped lang="scss">
  .del-root {
    p {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/bindFlexNet/UnBindFlexNet.vue